<template>
  <v-row justify="center">
    <v-dialog v-model="activate" persistent max-width="700px">
      <v-card>
        <v-card-title>
          <span class="headline">Přidat položku na sklad</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-row>
                <v-col cols="6">
                  <v-text-field v-model="name" :rules="nameRules" label="Název položky" required></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field v-model="units" label="Jednotky"></v-text-field>
                </v-col>
                <v-col cols="3">
                  <v-text-field v-model="min" type="number" label="Min.množství"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="selectedSuppliers"
                    :items="suppliers"
                    label="Dodavatelé"
                    multiple
                    item-text="name"
                    return-object
                  >
                    <template v-slot:selection="data">
                      <v-chip
                        v-bind="data.attrs"
                        :input-value="data.selected"
                        close
                        @click="data.select"
                        @click:close="remove(data.item)"
                      >{{ data.item.name }}</v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-for="(supplier,index) in selectedSuppliers" :key="supplier" >
                
                  <v-col cols="12">
                    {{supplier.name}}<v-text-field v-model="suppliersMerged[index].orderNo" label="Objednávací číslo" required></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    
                  </v-col>
    
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">Close</v-btn>
          <v-btn color="blue darken-1" text @click="validate">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar.visible" :timeout="3000">
      <v-icon>mdi-check</v-icon>
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar.visible = false">Close</v-btn>
      </template>
    </v-snackbar>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
export default {
  props: ["activate"],
  apollo: {
    suppliers: {
      query: gql`
        query {
          suppliers {
            _id
            name
          }
        }
      `,
    },
  },
  watch:{
    selectedSuppliers(newVal, oldVal){
      if(newVal > oldVal){
        this.suppliersMerged.push({_id: newVal[newVal.length-1]._id, orderNo: ""})
      }
      else{
         this.suppliersMerged.forEach(merged =>{
           var indexOfremoved = this.selectedSuppliers.findIndex(i => i._id === merged._id);
           if(indexOfremoved < 0){
              this.suppliersMerged.splice(indexOfremoved, 1);
           }
         })
      }
    }
  },
  data() {
    return {
      suppliers: [],
      selectedSuppliers: [],
      suppliersMerged:[],
      snackbar: {
        visible: false,
        message: "",
        icon: "mdi-check",
      },
      valid: true,
      name: null,
      nameRules: [],
      units: "ks",
      min: 1
    };
  },
  methods: {
    validate() {
      this.$refs.form.validate();
      if (this.valid) {
        this.$apollo
          .mutate({
            // Query
            mutation: gql`
              mutation($name: String!, $units: String!, $min: Int!, $supplier: [InputStockSupplier] ){
                createStock(
                  stockInput: {
                    name: $name
                    units: $units
                    min: $min
                    supplier: $supplier
                  }
                ) {
                  name
                }
              }
            `,
            variables: {
              name: this.name,
              units: this.units,
              min: this.min,
              supplier: this.suppliersMerged,
            },
          })
          .then(() => {
            this.qlDone(true);
          })
          .catch(() => {
            this.qlDone(false);
          });
      }
    },
    qlDone(success) {
      if (success) {
        this.snackbar = {
          visible: true,
          message: "Skladová položka uložena",
          icon: "mdi-check",
        };
        setTimeout(() => {
          this.close();
        }, 500);
      } else {
        this.snackbar = {
          visible: true,
          message: "Chyba",
          icon: "mdi-alert-circle",
        };
      }
    },
    close() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
      this.$emit("close-dialog", false);
    },
    remove(item) {
      const index = this.selectedSuppliers.indexOf(item);
      if (index >= 0) this.selectedSuppliers.splice(index, 1);
    },
  },
  mounted() {
    this.nameRules = [
      (v) => !!v || this.$t("forms.nameRequired"),
      (v) => (v && v.length <= 50) || this.$t("forms.nameMax"),
      (v) => (v && v.length > 2) || this.$t("forms.nameMin"),
    ];
    /*
    this.emailRules = [
      (v) => !!v || this.$t("forms.emailRequired"),
      (v) => /.+@.+\..+/.test(v) || this.$t("forms.emailValid"),
    ];
    */
  },
};
</script>